import { useQuery } from '@tanstack/react-query';
import { 
  getBatchLayerData, 
  getBatchConsumptionLog, 
  getBatchCogsSummary,
  getBatchTraceabilityReport,
  type BatchLayerData,
  type BatchConsumptionData,
  type BatchCogsSummary,
  type BatchTraceabilityReport
} from '@/services/batchTraceabilityService';

export function useBatchLayers(productId?: string) {
  return useQuery<BatchLayerData[]>({
    queryKey: ['batch-layers', productId],
    queryFn: () => getBatchLayerData(productId),
  });
}

export function useBatchConsumptionLog(filters?: {
  productId?: string;
  consumptionType?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
}) {
  return useQuery<BatchConsumptionData[]>({
    queryKey: ['batch-consumption-log', filters],
    queryFn: () => getBatchConsumptionLog(filters),
  });
}

export function useBatchCogsSummary(startDate: string, endDate: string) {
  return useQuery<BatchCogsSummary[]>({
    queryKey: ['batch-cogs-summary', startDate, endDate],
    queryFn: () => getBatchCogsSummary(startDate, endDate),
  });
}

export function useBatchTraceabilityReport(
  startDate?: string,
  endDate?: string,
  productId?: string
) {
  return useQuery<BatchTraceabilityReport>({
    queryKey: ['batch-traceability-report', startDate, endDate, productId],
    queryFn: () => getBatchTraceabilityReport(startDate, endDate, productId),
  });
}
